import React from 'react';
import { Slide } from '../components/deck/Slide';
import { Body, Caption, Eyebrow, Reveal, Title } from '../components/deck/Type';
const steps = [{
  n: '01',
  label: 'Capture inbound opportunities'
}, {
  n: '02',
  label: 'Ingest decks & data rooms'
}, {
  n: '03',
  label: 'Score against the thesis'
}, {
  n: '04',
  label: 'Generate diligence reports'
}, {
  n: '05',
  label: 'Surface risks, gaps, comparables'
}, {
  n: '06',
  label: 'Support the IC decision'
}, {
  n: '07',
  label: 'Monitor portfolio & valuations'
}, {
  n: '08',
  label: 'Feed organizational memory'
}];
export function SolutionSlide() {
  return <Slide index={5} data-id="element-234" data-mp="85dkr1pztard">
      <div className="flex items-start justify-between gap-[3vw]" data-id="element-235" data-mp="85nen0e5s22c">
        <div className="max-w-[62%]" data-id="element-236" data-mp="38dhszofwo4h">
          <Eyebrow data-id="element-237" data-mp="3595tg4qgo39">The solution</Eyebrow>
          <Title className="mt-[2.2vh]" data-id="element-238" data-mp="29x9wocg2ommo">
            DiligenceGPT™ turns fragmented deal flow into repeatable investment
            intelligence.
          </Title>
        </div>
        <Caption className="max-w-[28%] text-right" data-id="element-239" data-mp="3txvgypjousby">
          One end-to-end workflow, inside a single venture operating system.
        </Caption>
      </div>

      <div className="mt-auto" data-id="element-240" data-mp="1um5a9wz0m0c">
        <div className="relative" data-id="element-241" data-mp="1rq66i9dzrab">
          <div className="absolute left-0 right-0 top-[0.75vh] h-px bg-white/12" data-id="element-242" data-mp="6sxeqjjcsui1" />
          <div className="relative grid grid-cols-8 gap-[1vw]" data-id="element-243" data-mp="bjma49y5mbmg">
            {steps.map((s, i) => <Reveal key={s.n} delay={0.05 * i} data-id="element-244" data-mp="gjic63najszd" data-mpi={i}>
                <div className="h-[1.5vh] w-[1.5vh] rounded-full" style={{
              background: i === 7 ? '#2FBE8F' : '#3B8CFF',
              opacity: 0.5 + i * 0.07
            }} data-id="element-245" data-mp="gipdzr2eebsu" />
                <p className="mt-[1.8vh] text-[clamp(8px,0.8vw,17px)] tracking-[0.2em] text-white/35" data-id="element-246" data-mp="uj0770r6k2h6">
                  {s.n}
                </p>
                <p className="mt-[0.8vh] text-[clamp(9.5px,1vw,21px)] leading-[1.35] text-[#DCE3EE]" data-id="element-247" data-mp="2rd4pnd0yvk66">
                  {s.label}
                </p>
              </Reveal>)}
          </div>
          <div className="mt-[2vh] flex justify-end" data-id="element-248" data-mp="3hqvz4yng15b">
            <span className="text-[clamp(7.5px,0.78vw,16px)] uppercase tracking-[0.22em] text-[#2FBE8F]" data-id="element-249" data-mp="3umzbl8p3vro4">
              Memory returns to step one
            </span>
          </div>
        </div>

        <Reveal delay={0.44} className="mt-[3vh] grid grid-cols-[58%_1fr] items-end gap-[3vw] border-t border-white/12 pt-[2.6vh]" data-id="element-250" data-mp="7gyjmy36pxfv">
          <p className="text-[clamp(15px,1.75vw,36px)] leading-[1.25] text-[#F4F7FC]" style={{
          fontFamily: 'var(--font-serif)'
        }} data-id="element-251" data-mp="mc5y33g9c9xd">
            A scout, analyst, associate, portfolio monitor and institutional
            memory layer — working inside one venture operating system.
          </p>
          <Body data-id="element-252" data-mp="154gpo15golg6">
            DiligenceGPT™ does not replace investment teams. It gives every team
            member stronger data, faster analysis and more time for judgment and
            relationships.
          </Body>
        </Reveal>
      </div>
    </Slide>;
}